const _i18n_error = {
  license_failed: {
    EN: `license check failed`,
    KO: `license check failed`,
    JP: `ライセンスチェックに失敗しました`
  }
}

const i18n_toastr = { _i18n_error }

export default i18n_toastr